module.exports = __webpack_public_path__ + "img/dawg-camp-innovate.4681664d.jpg";